import SlsWorkFlowDirecionamentoClient from '@/api/SistemaDKP/Workflow/sis-workflowdirecionamento.client';

import { ErrorMessage } from '@/libs/Error';

export default class SLSWorkFlowDirecionamentoService {
  constructor() {
    this.client = new SlsWorkFlowDirecionamentoClient();
    this.error = new ErrorMessage();
  }

  async index(queries) {
    try {
      const { data } = await this.client.index(queries);
      return data;
    } catch (error) {
      this.error.message(error, 'Erro ao listar os workflow direcionamento');
    }
  }

  async store(data) {
    try {
      const { data: response } = await this.client.store(data);
      return response;
    } catch (error) {
      this.error.message(error, 'Erro ao criar Workflow Direcionamento');
    }
  }

  async show(id) {
    try {
      const { data } = await this.client.show(id);
      return data;
    } catch (error) {
      this.error.message(error, 'Erro ao buscar Workflow Direcionamento');
    }
  }

  async update(data) {
    try {
      const { data: response } = await this.client.update(data);
      return response;
    } catch (error) {
      this.error.message(error, 'Erro ao atualizar Workflow Direcionamento');
    }
  }

  async destroy(body) {
    try {
      const { data: response } = await this.client.destroy(body);
      return response;
    } catch (error) {
      this.error.message(error, 'Erro ao deletar Workflow Direcionamento');
    }
  }
}
